import { render, staticRenderFns } from "./TopShareHolders.vue?vue&type=template&id=971716d2"
import script from "./TopShareHolders.vue?vue&type=script&lang=js"
export * from "./TopShareHolders.vue?vue&type=script&lang=js"
import style0 from "./TopShareHolders.vue?vue&type=style&index=0&id=971716d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports